// const ERP_URL = "http://localhost:8000";
// const ERP_URL = "https://nbpadmin.360magic.link"; // prod
// const ERP_URL = "http://172.30.91.191"; // prod
//const ERP_URL = "http://196.188.118.234:8000"; // prod
//const ERP_URL = "https://new.bo.business.gov.et"; // prod
//192.168.1.128
// const ERP_URL = "http://196.188.118.234";
const ERP_URL = "https://bo.business.gov.et";

const CLIENT_URL = "https://new.business.gov.et";
// const CLIENT_URL = "https://nbp.360magic.link"; //prod
// const CLIENT_URL = "http://172.30.91.190:5000"; //prod
// const CLIENT_URL = "http://196.189.50.12"; //prod
//const CLIENT_URL = "https://www.new.business.gov.et"; //prod

const GET_USER_APPLICATIONS =
  "stars_et.stars_et.doctype.applications.applications.get_user_applications";
const GET_APPLICATIONS =
  "stars_et.stars_et.doctype.applications.applications.get_applications";
const GET_APPLICATION_DATA =
  "stars_et.stars_et.doctype.applications.applications.get_application_data";
const CHECK_STEP_USER =
  "stars_et.stars_et.doctype.applications.applications.check_step_user";
const UPDATE_MISSING_FORM_VISIBILITY =
  "stars_et.stars_et.doctype.evaluation_submission.evaluation_submission.update_missing_form_visibility";
const GET_EVALUATION_DATA =
  "stars_et.stars_et.doctype.evaluation_submission.evaluation_submission.get_evaluation_data";
const GET_CERTIFICATE_DATA =
  "stars_et.stars_et.doctype.evaluation_submission.evaluation_submission.get_certificate_data";

const GET_SINGLE_APPLICATION_DETAIL =
  "stars_et.stars_et.doctype.application_process.application_process.get_single_application_detail";

const SEND_COMMENT =
  "stars_et.stars_et.doctype.evaluation_submission.evaluation_submission.send_message_evaluator";

const SUBMIT_EVALUATION =
  "stars_et.stars_et.doctype.evaluation_submission.evaluation_submission.submit_evaluation";

const REJECT_EVALUATION =
  "stars_et.stars_et.doctype.evaluation_submission.evaluation_submission.reject_evaluation";

const SERVICE_REPORT =
  "stars_et.stars_et.doctype.applications.applications.service_level_report";

const SERVICE_LIST =
  "stars_et.stars_et.doctype.applications.applications.service_list";
const SUBMIT_EVALUATION_ASYNC =
  "stars_et.stars_et.doctype.evaluation_submission.evaluation_submission.submit_evaluation_async";
export {
  ERP_URL,
  CLIENT_URL,
  GET_USER_APPLICATIONS,
  GET_APPLICATIONS,
  GET_APPLICATION_DATA,
  CHECK_STEP_USER,
  UPDATE_MISSING_FORM_VISIBILITY,
  GET_SINGLE_APPLICATION_DETAIL,
  GET_EVALUATION_DATA,
  GET_CERTIFICATE_DATA,
  SEND_COMMENT,
  SUBMIT_EVALUATION,
  SUBMIT_EVALUATION_ASYNC,
  REJECT_EVALUATION,
  SERVICE_REPORT,
  SERVICE_LIST,
};
